import React from 'react';
import { Compass, HeartHandshake, Building2, Trophy } from 'lucide-react';

const WhyChooseSection = () => {
  const features = [
    {
      id: 'personalized',
      step: '01',
      icon: <Compass size={28} className="why-choose-icon-svg" />,
      title: 'Personalized Risk Guidance',
      description:
        'Identify and understand the risks that matter to you or your business, with guidance tailored to your specific needs.',
    },
    {
      id: 'life-expertise',
      step: '02',
      icon: <HeartHandshake size={28} className="why-choose-icon-svg" />,
      title: 'Life Insurance Expertise',
      description:
        'With thorough knowledge of life insurance, Meena helps families plan protection around their long-term financial needs.',
    },
    {
      id: 'msme-corporate',
      step: '03',
      icon: <Building2 size={28} className="why-choose-icon-svg" />,
      title: 'MSME & Corporate Expertise',
      description:
        'Specialized solutions for businesses focused on risk management, sustainability, and continuity across generations.',
    },
    {
      id: 'recognized',
      step: '04',
      icon: <Trophy size={28} className="why-choose-icon-svg" />,
      title: 'Recognized Experience',
      description:
        'Recognized through professional achievements including LIC Top Performer honors and a Guinness World Record recognition.',
    },
  ];

  return (
    <section className="why-choose-section" id="why-choose">
      <div className="why-choose-container">
        <div className="why-choose-grid">
          
          {/* Left Column: Sticky Title & Description */}
          <div className="why-choose-left-sticky">
            <div className="sticky-content-box">
              <span className="why-choose-badge">Why Choose Meena</span>
              <h2 className="why-choose-title">
                WHY CHOOSE MEENA<br />FOR YOUR INSURANCE NEEDS?
              </h2>
              <p className="why-choose-desc">
                With deep experience in life insurance and risk management,
                Meena provides thoughtful guidance to help individuals,
                families, and businesses plan for greater security and continuity.
              </p>
            </div>
          </div>

          {/* Right Column: Stacked Cards that Scroll Past */}
          <div className="why-choose-right-cards">
            {features.map((item) => (
              <div key={item.id} className="why-choose-card">
                <div className="why-choose-card-top-row">
                  <span className="why-choose-step-num">{item.step}</span>
                  <div className="why-choose-card-icon">{item.icon}</div>
                </div>
                <div className="why-choose-card-text">
                  <h3 className="why-choose-card-title">{item.title}</h3>
                  <p className="why-choose-card-desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
